// import type8Credits from "@jeremyfagis/type8-credits";
import { textAnimations } from './utils/text-animations';

export default function () {
    // -------------------------------------
    // type8 credits
    // -------------------------------------
    // new type8Credits('.type8_open');

    // -------------------------------------
    // Texts animations
    // -------------------------------------
    textAnimations();
}
